import { Helmet } from "react-helmet-async";

const SITE_URL = "https://holy-wanderer.emergent.host";
const DEFAULT_OG = "https://images.unsplash.com/photo-1677434654722-69e7ba88b4ef?w=1200";

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  jsonLd = null,
  noindex = false,
}) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="RSK Tours" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export const SITE = SITE_URL;
